import axios from "axios"
import { LandingPageScienceProduct } from "shared/types/science35Types"

export interface RequestScienceAccountsProps {
    name: string
    email: string
    numOfStudents: number
    product: LandingPageScienceProduct
    comment?: string
    state: string
}

export async function requestScienceAccount(data: RequestScienceAccountsProps) {
    const res = await axios.post("/api/request-science-account", data)
    return res
}
